import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Wrapper = styled.div`
  margin-bottom: 20px;

  & > h3 {
    margin-left: 10px;
  }
  & > div {
    padding: 10px;
    background-color: white;
  }
`;

export default function PayrollDetailSection({ title, children, style }) {
  return (
    <Wrapper style={{ ...style }}>
      <h3>{title}</h3>
      <div>{children}</div>
    </Wrapper>
  );
}

PayrollDetailSection.propTypes = {
  title: PropTypes.string.isRequired,
  style: PropTypes.shape(),
  children: PropTypes.node.isRequired,
};

PayrollDetailSection.defaultProps = {
  style: {},
};
